export const load_stock_configs = (device_type) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'LOAD_STOCK_CONFIGS__REQUEST', device_type });
    try {
        const response = await api.get_stock_configs(device_type);
        dispatch({
            type: 'LOAD_STOCK_CONFIGS__OK',
            device_type,
            configs: response.configs,
        });
    }
    catch (error) {
        dispatch({
            type: 'LOAD_STOCK_CONFIGS__FAIL',
            device_type,
            error: error?.json?.error_ui ?? 'Не удалось загрузить конфигурации',
        });
    }
};
export const apply_stock_config = (device_id, config_id) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'APPLY_STOCK_CONFIG__REQUEST', device_id, config_id });
    try {
        const response = await api.apply_stock_config(device_id, config_id);
        dispatch({
            type: 'APPLY_STOCK_CONFIG__OK',
            device_id,
            config_id,
            result_config: response.result_config,
        });
    }
    catch (error) {
        dispatch({
            type: 'APPLY_STOCK_CONFIG__FAIL',
            device_id,
            config_id,
            error: error?.json?.error_ui ?? 'Не удалось отправить запрос',
        });
    }
};
export const close_apply_stock_config_confirmation = (device_id) => ({
    type: 'CLOSE_APPLY_STOCK_CONFIG_CONFIRMATION',
    device_id,
});
